export const formatReportData = (data?: { [key: string]: string }[]) => {
  return data?.map((elem: { [key: string]: string }) => Object.keys(elem).toString()) || [];
};
